module.exports = __webpack_public_path__ + "open-iconic.93cc7aa654ae36b08287.ttf";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/assets/open-iconic-master/font/fonts/open-iconic.ttf
// module id = ../../../../../src/assets/open-iconic-master/font/fonts/open-iconic.ttf
// module chunks = styles